import { put, call, takeLatest } from 'redux-saga/effects';
import { createAction, SimpleActionType, assign } from '../utils/storeUtils';
import { apiFetch, FetchResponse } from '../novaApi/apiUtils';

const FETCH_SONG_TAGS = 'FETCH_SONG_TAGS';
const FETCH_SONG_TAGS_SUCCESS = 'FETCH_SONG_TAGS_SUCCESS';
const FETCH_SONG_TAGS_ERROR = 'FETCH_SONG_TAGS_ERROR';

// Action creator
export const fetchSongTags = createAction(FETCH_SONG_TAGS);
const fetchSongTagsSuccess = createAction(FETCH_SONG_TAGS_SUCCESS);
const fetchSongTagsError = createAction(FETCH_SONG_TAGS_ERROR);

// Reducer
const initialState = {
  data: {
    song_tags: [] as Nl.SongTag[],
    total_size: 0,
    current_size: undefined as number | undefined,
    current_page: undefined as number | undefined,
    offset: undefined as number | undefined,
    total_pages: undefined as number | undefined,
  },
  isLoading: false,
  isLoaded: false,
};

export type SongTags = Readonly<typeof initialState>;

const reducer = (state = initialState, action: SimpleActionType) => {
  switch (action.type) {
    case FETCH_SONG_TAGS_SUCCESS:
      return assign(state, {
        data: action.payload.data,
        isLoading: false,
        isLoaded: true,
      });

    default:
      return state;
  }
};

const sagas = {
  *fetchSongTagsSaga() {
    const results: FetchResponse<Nl.Api.SongTagsResponse> = yield call(
      apiFetch,
      '/song_tag/select',
    );
    if (results.success) {
      yield put(
        fetchSongTagsSuccess({
          data: {
            ...results.data,
            song_tags: results.data.song_tags.map((tag) => ({
              name: tag.name,
              uuid: tag.name,
            })),
          },
        }),
      );
    } else {
      yield put(fetchSongTagsError({ error: results.msg }));
    }
  },
};

export function* rootSaga() {
  yield takeLatest(FETCH_SONG_TAGS, sagas.fetchSongTagsSaga);
}
export { sagas };
export default reducer;
